import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, url, image, robots = "index,follow" }:any) {
  const baseTitle = "MikroSell CarWash POS";
  const pageTitle = title ? `${title} | ${baseTitle}` : baseTitle;
  const site = "https://carwash.mikrosell.com";
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url || site} />
      <meta name="robots" content={robots} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url || site} />
      <meta property="og:image" content={image || `${site}/hero-image-dark.png`} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || `${site}/hero-image-dark.png`} />
    </Helmet>
  );
}
